import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { Divider } from "@/components/General/Dropdown/components/divider";

import { Preview } from "../preview/preview";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    return (
        <>
            <div className={cn("tw:flex tw:justify-end")}>{children}</div>
            <Divider />
            <div
                className={cn(
                    "tw:md:hidden tw:w-full tw:mb-3",
                    "tw:sticky tw:top-0 tw:pt-4 tw:bg-white tw:layer-base/[10]"
                )}
            >
                <Preview />
            </div>
        </>
    );
};

export { Base };
